import { Row } from 'antd';
import styled from 'styled-components';

export const PageLabel = styled.span`
  margin-right: 8px;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  padding-left: 18px;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const FilterContent = styled.div`
  .ant-divider {
    color: var(--white-gray);
    margin: 0 -8px;
    width: calc(100% + 16px);
  }
`;

export const FilterHeader = styled.div`
  font-size: 16px;
  line-height: 20px;
  color: var(--secondary);
  font-weight: 600;

  padding: 10px;

  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SharedPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const SharedPageWrapper2 = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  .ant-tabs,
  .ant-tabs-content,
  .ant-tabs-tabpane {
    height: 100%;
  }
`;

export const SharedContentWrapper = styled.div<{
  subSegregationVisible?: boolean;
}>`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: start;
  height: 100%;
  ${({ subSegregationVisible }) =>
    subSegregationVisible ? 'padding: 0 20px;' : 'padding: 20px 20px 0;'}
  overflow: hidden;

  @media (max-width: 768px) {
    padding: 0;
  }

  .blur-column {
    filter: blur(8px);
  }

  > .ant-table-wrapper {
    flex: 1;

    /* .ant-spin-nested-loading,
    .ant-spin-container,
    .ant-table-fixed-header,
    .ant-table-container,
    .ant-table-body {
      height: 100%;
    } */
  }
`;

export const MainLabel = styled.div`
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;

  color: var(--secondary);
  margin-bottom: 20px;

  @media screen and (max-width: 768px) {
    margin-bottom: 3rem;
  }
`;

export const CustomLabel = styled.div`
  font-size: 14px;
  line-height: 16px;
  font-weight: 600;
  color: var(--secondary);
`;

export const BoldTag = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;

  @media (min-width: 768px) {
    font-weight: 500;
  }
`;

export const StrongTag = styled.div`
  display: flex;
  font-weight: 500;
`;

export const FilterDatePickerWrapper = styled(Row)`
  align-items: center;
  gap: 10px;

  > .rhf-controlled-input {
    flex: 1;
  }

  .divider {
    width: 8px;
    height: 2px;
    background: var(--gray);
  }
`;

export const NoWrapSpan = styled.div`
  white-space: nowrap;
`;

export const CenterModalTitle = styled.div`
  text-align: center;
`;

export const TextWrapper = styled.p`
  overflow-wrap: break-word;
  max-width: 350px;
`;

export const FilterBody = styled.div`
  padding: 22px 16px 16px;
`;
